import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
  padding: 0px;
  border-radius: 4px;
  border: none;
  background-color: var(--secondary);
  padding: 14px;
  font-weight: bold;
  color: var(--secondary-text);
  width: 180px;
  cursor: pointer;
  box-shadow: 0px 6px 0px 0px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px 0px rgba(173, 185, 35, 1);
  -moz-box-shadow: 0px 6px 0px 0px rgba(173, 185, 35, 1);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 4px;
  border: none;
  background-color: var(--secondary);
  padding: 20px;
  font-weight: medium;
  font-size: 20px;
  color: var(--secondary-text);
  width: 43px;
  height: 43px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px 0px rgba(173, 185, 35, 1);
  -webkit-box-shadow: 0px 4px 0px 0px rgba(173, 185, 35, 1);
  -moz-box-shadow: 0px 4px 0px 0px rgba(173, 185, 35, 1);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 1200px) {
    flex-direction: row;
  }
`;

export const StyledImg = styled.img`
  width: 200px;
  @media (min-width: 400px) {
    width: 200px;
  }
  @media (min-width: 800px) {
    width: 400px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--secondary);
  text-decoration: none;
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(``);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 66) {
      newMintAmount = 66;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (
    <s.Screen>
      <s.Container
        flex={1}
        ai={"center"}
        // style={{ padding: 24, backgroundImage: "linear-gradient(#E1F664, #FEB0FE)" }}
        image={CONFIG.SHOW_BACKGROUND ? "/config/images/bg.png" : null}
      >
        <ResponsiveWrapper flex={1} style={{ padding: 12 }} test>
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <StyledImg alt={"Halfie Right NFT"} src={"/config/images/halfies.gif"} />
          </s.Container>
          
          <s.Container
            flex={2}
            jc={"center"}
            ai={"center"}
            style={{
              padding: 24,
              borderRadius: 8,
            }}
          >
            <s.Container ai={"center"} jc={"center"} fd={"row"}>

            <StyledLink target={"_blank"} href={"http://www.gomotoys.com/"}>  
            <StyledImg alt={"Halfie NFT Logo"} src={"/config/images/gomotoys.png"} 
            style={{
              height: 40,
              width: 180,
              padding: 2,
            }}
            />
             </StyledLink>

            <s.SpacerMedium />

            <StyledLink target={"_blank"} href={"https://twitter.com/gomotoys"}>
            <StyledImg alt={"Twitter Link"} src={"/config/images/twitter.png"} 
            style={{
              padding: 2,
              height: 42,
              width: 42,
            }}
            />
            </StyledLink>

            <s.SpacerXSmall />

            <StyledLink target={"_blank"} href={"https://opensea.io/collection/halfies"}>
            <StyledImg alt={"Opensea Link"} src={"/config/images/opensea.png"} 
            style={{
              padding: 2,
              height: 42,
              width: 42,
            }}
            />
            </StyledLink>

            <s.SpacerXSmall />

            <StyledLink target={"_blank"} href={"https://etherscan.io/address/0xc6d065b226F3A6562d940905eB956Bdea915d570"}>
            <StyledImg alt={"Etherscan Link"} src={"/config/images/etherscan.png"} 
            style={{
              padding: 2,
              height: 42,
              width: 42,
            }}
            />
            </StyledLink>
            </s.Container>
            
            <s.SpacerMedium />
            <StyledImg alt={"Halfie NFT Logo"} src={"/config/images/halfies.png"} />
            <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 80,
                fontWeight: "bold",
                color: "var(--accent-text)",
              }}
            >
              {data.totalSupply} / {CONFIG.MAX_SUPPLY}
            </s.TextTitle>
            <s.TextDescription
              style={{
                textAlign: "center",
                fontWeight: "bold",
                color: "var(--accent-text)",
              }}
            >
              <p>0.02 ETH / Mint</p>
            </s.TextDescription>
            {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
              <>
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  The sale has ended.
                </s.TextTitle>
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  You can still find {CONFIG.NFT_NAME} on
                </s.TextDescription>
                <s.SpacerSmall />
                <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                  {CONFIG.MARKETPLACE}
                </StyledLink>
              </>
            ) : (
              <>
                <s.SpacerSmall />
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>

                    <s.SpacerSmall />
                    <StyledButton
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                      }}
                    >
                      Connect Metamask
                    </StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {feedback}
                    </s.TextDescription >
                    <s.SpacerMedium />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledRoundButton
                        style={{ lineHeight: 0.4 }}
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          decrementMintAmount();
                        }}
                      >
                        -
                      </StyledRoundButton>
                      <s.SpacerMedium />
                      <s.TextTitle
                        style={{
                          textAlign: "center",
                          color: "var(--accent-text)",
                        }}
                      >
                        {mintAmount}
                      </s.TextTitle>
                      <s.SpacerMedium />
                      <StyledRoundButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          incrementMintAmount();
                        }}
                      >
                        +
                      </StyledRoundButton>
                    </s.Container>
                    <s.SpacerSmall />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          claimNFTs();
                          getData();
                        }}
                      >
                        {claimingNft ? "Processing" : "Mint"}
                      </StyledButton>
                    </s.Container>
                  </>
                )}
              </>
            )}
             
            <s.SpacerLarge />
            <s.SpacerLarge />
            <s.TextDescription
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "var(--accent-text)",
                }}
              >
                <p>Halfies are a collection of 666 unique generated NFTs.<br></br>They first came to life in 2012 in resin form and now they comeback in the virtual world.<br></br> 66 Ancestors, 600 Descendants.</p>
                <br></br><p>Each Halfie has 6 unique views. Top, Bottom, Left, Right, Front and Back!</p>
        </s.TextDescription>
          </s.Container>
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <StyledImg
              alt={"Halfie Left NFT"}
              src={"/config/images/halfies.gif"}
              style={{ transform: "scaleX(-1)" }}
            />
          </s.Container>
        </ResponsiveWrapper>
        <s.SpacerMedium />
        <s.Container jc={"center"} ai={"center"} style={{ width: "70%" }}>
          <s.SpacerSmall />
        </s.Container>
      </s.Container>
    </s.Screen>
  );
}

export default App;
